import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { ENVIRONMENT_TYPE } from "./constant/common";
import { environment } from "./constant/environment";
import "./constant/environment";
import { initializeSentry } from "./constant/sentryConfiguration";
import ContextProvider from "./context";
import { checkAndClearStorageIfNeeded } from "./hooks/localStorage";
import { ToastProvider } from "./utils/ToastProvider";
import { sanitizeStaleBookingSession } from "./utils/booking/sanitizeStaleBookingSession";
import { GoogleOAuthProvider } from '@react-oauth/google';


checkAndClearStorageIfNeeded();
// A non-resumable booking step (review/traveller/payment) persisted in storage
// cannot survive a hard reload — its working state and backend prebook session
// are gone. Reset it BEFORE ContextProvider reads booking state so the user
// lands on Home instead of a blank, exit-less review. See the util for details.
sanitizeStaleBookingSession();

if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";

// Defer Sentry init off the critical path — it runs synchronously and was
// blocking ~500ms of parse time before first React render.
const deferSentry = () => initializeSentry();
if (typeof (window as any).requestIdleCallback === "function") {
  (window as any).requestIdleCallback(deferSentry, { timeout: 3000 });
} else {
  setTimeout(deferSentry, 0);
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  environment === ENVIRONMENT_TYPE.PRODUCTION ? (
    <GoogleOAuthProvider clientId="411192459575-eoiroo0nqrht0mtfuh13p4tojof2i65r.apps.googleusercontent.com">
      <BrowserRouter>
        <ContextProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </ContextProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  ) : (
    <GoogleOAuthProvider clientId="411192459575-eoiroo0nqrht0mtfuh13p4tojof2i65r.apps.googleusercontent.com">
      <BrowserRouter>
        <ContextProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </ContextProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  )
);